let URL;
switch (process.env.NODE_ENV) {
  case "production":
    URL = "https://wms-api.tapdoandaiviet.com.vn/";
    break;
  case "uat":
    URL = "https://wms-api-uat.baspro.vn/";
    break;
  case "staging":
    URL = "https://wms-api-staging.baspro.vn/";
    break;
  case "test":
    URL = "https://wms-api-test.baspro.vn/";
    break;
  default:
    URL = "http://localhost:21021/";
    break;
}
export default URL;
